import { Checkbox } from "@mantine/core";
import { useInputStyles } from "./FieldTextValue";

type Props = {
  formProps: any;
  label: React.ReactNode;
};

export default function FieldCheckboxValue({ formProps, label }: Props) {
  const { classes } = useInputStyles();
  return (
    <Checkbox
      label={label}
      size="sm"
      variant="default"
      {...formProps}
      classNames={{ label: classes.checkBoxLabel }}
    />
  );
}
